import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';

import { homePageViewRoute } from '../routes';
import type { OptionalAppRoute } from '../types';

/** The part of the router context that a legacy view match reads. */
export interface LegacyViewContext {
    /** Id of the Angular JS view in view, when the page is served by the legacy application. */
    currentView?: string;
    /** Parameters of that legacy view. */
    params?: Record<string, any>;
}

/**
 * Whether the page in view is the legacy Angular JS view of the given route.
 *
 * The legacy application reports its view through the router context, so the URL says nothing
 * there. Returns false as soon as the context reports no legacy view.
 *
 * TODO: remove this once we have migrated to full react
 */
export const doesLegacyViewMatch = (context?: LegacyViewContext, route?: OptionalAppRoute<any>): boolean => {
    if (!context?.currentView) {
        return false;
    }

    const { currentView, params } = context;
    const doesMatchLegacyId = currentView === route?.legacyId;

    /**
     * Every content shares one legacy id, so the home page is told from another content by its
     * slug, and the home page is the one without a slug.
     */
    if (isEqual(route, homePageViewRoute)) {
        return doesMatchLegacyId && !params?.slug;
    }

    if (doesMatchLegacyId && route?.params) {
        const onlyProvidedParams = pick(params, Object.keys(route.params));

        return isEqual(onlyProvidedParams, pick(route.params, Object.keys(onlyProvidedParams)));
    }

    return doesMatchLegacyId;
};
